// Vendored from google-map-react v1's lib/utils/lib_geo/lat_lng.js. v2 ships
// only a bundled dist/ with no public LatLng export, so this pure geo value —
// usable before the Google Maps API has loaded — now lives in-repo.
export type LatLngLike =
  LatLng | [number, number] | { lat: number; lng: number }

export default class LatLng {
  lat: number

  lng: number

  constructor(lat: number, lng: number) {
    if (Number.isNaN(Number(lat)) || Number.isNaN(Number(lng))) {
      throw new Error(`Invalid LatLng object: (${lat}, ${lng})`)
    }
    this.lat = +lat
    this.lng = +lng
  }

  static convert(a: LatLngLike): LatLng {
    if (a instanceof LatLng) {
      return a
    }
    if (Array.isArray(a)) {
      return new LatLng(a[0], a[1])
    }
    return new LatLng(a.lat, a.lng)
  }
}
